import Passenger from '../passenger/passenger'
export default class IntlFlightOrder { // 国际航班订单类
  constructor(details) {
    if (details) {
      for (let key of Object.keys(details)) {
        this[key] = details[key] ? JSON.parse(JSON.stringify(details[key])) : null
      }
    }
    this.SearchParams = details && details.SearchParams ? details.SearchParams : {
      Segments: [{
        DepartObject: {}, // 前端用于显示, 自定义的出发对象
        ArrivalObject: {}, // 前端用于显示, 自定义的到达对象
        DepartureTime: this.beTime(new Date().setDate(new Date().getDate() + 1)),
        DepartureAirportCode: '',
        ArrivalAirPortCode: ''
      }],
      DirectFlight: false,
      OriginOrderID: '', // 原订单ID（改签查询才有）
      FlightClass: '',
      AdultCount: 1,
      ChildCount: 0,
      InfantCount: 0,
      AirLine: ''
    } // 查询国际航班参数
    this.SelectedSegmentIDs = details && details.SelectedSegmentIDs ? details.SelectedSegmentIDs : [] // 选择的航段ID列表
    this.SelectedFareInfoID = details && details.SelectedFareInfoID ? details.SelectedFareInfoID : '' // 选择的价格信息ID
    this.ChangeType = details && details.ChangeType ? details.ChangeType : 0 // 改期类型自愿非自愿
    this.ChangeReason = details && details.ChangeReason ? details.ChangeReason : '' // 改期原因
    this.TravelType = details && details.TravelType ? details.TravelType : '' // 旅游类型 0:因公 1:因私
    this.AuthorizationCode = details && details.AuthorizationCode ? details.AuthorizationCode : '' // 授权码
    this.Purpose = details && details.Purpose ? details.Purpose : '' // 差旅目的
    this.Passengers = details && details.Passengers ? this.setPassenger(details.Passengers) : [] // 常旅客
    this.CustomItem = details && details.CustomItem ? details.CustomItem : {} // 自定义项(所有乘客一样)
    this.Contacts = details && details.Contacts ? details.Contacts : [] // 联系人信息
    this.PayType = details && details.PayType ? details.PayType : null // 支付类型
    this.AppointVettingPersonID = details && details.AppointVettingPersonID ? details.AppointVettingPersonID : '' // 选择的指定审批人ID
    this.AppointVettingPersonName = details && details.AppointVettingPersonName ? details.AppointVettingPersonName : '' // 选择的指定审批人姓名
    this.TotalPrice = details && details.TotalPrice ? details.TotalPrice : 0 // 总金额

    this.ExtendField1 = details && details.ExtendField1 ? details.ExtendField1 : '' // 扩展字段1
    this.ExtendField2 = details && details.ExtendField2 ? details.ExtendField2 : '' // 扩展字段2
    this.ExtendField3 = details && details.ExtendField3 ? details.ExtendField3 : '' // 扩展字段3
    this.ExtendField4 = details && details.ExtendField4 ? details.ExtendField4 : '' // 扩展字段4
    this.ExtendField5 = details && details.ExtendField5 ? details.ExtendField5 : '' // 扩展字段5
    this.AttachFiles = details && details.AttachFiles ? details.AttachFiles : [] // 上传附件
    /** 其他自定义参数, 便于下单流程中使用 */
    this.RequestSegmentIndex = details && details.RequestSegmentIndex ? details.RequestSegmentIndex : 1
    this.SelectedSegment = details && details.SelectedSegment ? details.SelectedSegment : []
    this.PageBtnInfo = details && details.PageBtnInfo ? details.PageBtnInfo : {
      IsAllowCancel: false,
      IsAllowPay: false,
      IsAllowPayAndSubmit: false,
      IsAllowSubmit: false
    }
    this.OrderResults = details && details.OrderResults ? details.OrderResults : []
    this.RuleInfo = details && details.RuleInfo ? details.RuleInfo : [] // 退改签
    this.FareInfos = details && details.FareInfos ? details.FareInfos : [] // 价格信息, 行李信息
  }
  beTime(ms, format = 'yyyy-MM-dd') {
    let isDate = ms instanceof Date
    if (!isDate && `${ms}`.includes('-') && !`${ms}`.startsWith('-')) {
      let year = '1900'
      let month = '01'
      let day = '01'
      let hours = '00'
      let minutes = '00'
      let seconds = '00'
      let res = ''
      if (ms.includes(' ')) {
        let date = ms.split(' ')[0]
        year = date.split('-')[0]
        month = date.split('-')[1]
        day = date.split('-')[2]
        let time = ms.split(' ')[1]
        let timelist = time.split(':')
        timelist.length > 0 && (hours = timelist[0]);
        timelist.length > 1 && (minutes = timelist[1]);
        timelist.length > 2 && (seconds = timelist[1]);
        res = format.replace('yyyy', year).replace('MM', month).replace('dd', day).replace('hh', hours).replace('mm', minutes).replace('ss', seconds)
      } else {
        year = ms.split('-')[0]
        month = ms.split('-')[1]
        day = ms.split('-')[2]
        res = format.replace('yyyy', year).replace('MM', month).replace('dd', day)
      }
      return res
    } else {
      let date = ''
      if (isDate) {
        date = new Date(ms)
      } else {
        let val = ms.toString().length <= 10 ? ms * 1000 : ms
        date = new Date(val)
      }
      /** 将获取的日期格式转成北京时间 */
      // let currentDate = new Date()
      // let tmpMins = date.getMinutes()
      // let timeZone = currentDate.getTimezoneOffset() + 480
      // date = new Date(date.setMinutes(tmpMins + timeZone))
      /**********************************************************************************************/
      var fmt = format // yyyy-MM-dd hh:mm
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
      }
      return fmt
    }
  }
  setPassenger(list = []) {
    let res = list.map(v => {
      return new Passenger(v)
    })
    return res
  }
}
